import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import PdfViewer from "../../components/PdfViewer";

const getPdfUrl = locale =>
  ({
    [locale]:
      "https://cdn.terras.agr.br/files/politica-de-privacidade-terras-2021-04-27.pdf",
    'en-US': 'https://cdn.terras.agr.br/files/politica-de-privacidade-terras-2021-04-27.pdf'
  }[locale]);

const PrivacyPolicy = () => {
  const { formatMessage, locale } = useIntl();
  const [pdfUrl, setPdfUrl] = useState(getPdfUrl(locale));

  useEffect(() => {
    setPdfUrl(getPdfUrl(locale));
  }, [locale]);

  return (
    <>
      <h1>{formatMessage({ id: "politica-privacidade" })}</h1>

      <div className="content-box privacy-policy">
        <PdfViewer
          url={pdfUrl}
          title={formatMessage({ id: "politica-privacidade" })}
        />
      </div>
    </>
  );
};

export default PrivacyPolicy;
